import React from 'react';
import OKAPI from '@api';
import config from '@root/config';
import to from 'await-to-js';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const QueueFindContext = React.createContext();

const FOUND = 200;
const NOT_FOUND = 404;

class QueueFindProvider extends React.Component {

    state = {
        showForm: false,
        isLoading: false,
        patient: {},
        errMessage: '',
        isError: false,
        isBpjs: false,
        statusCode: null,
    }

    findPatient = async(params = null) => {
        const isBpjs = (_get(params, 'patient_search_type') === config.BPJS_SEARCH);
        this.setState({
            isLoading: true,
            isError: false,
            isBpjs
        });

        let { errMessage } = this.state;
        const resp = await OKAPI.qms.FindPatient(params);
        const resCode = _get(resp, 'status');
        const isOk = resCode === FOUND;
        const isNotFound = resCode === NOT_FOUND;
        const data = _get(resp, 'data.data') || {};
        let patient = {
            patientData: _get(data, 'patient_data') || {}
        };

        if (!_isEmpty(data)) {
            patient.JSONSchema = _get(data, 'json_form.json_schema') || {};
            patient.UISchema = _get(data, 'json_form.ui_schema') || {};
            patient.ErrorSchema = _get(data, 'json_form.error_schema') || {};
        } 

        let isError = false;
        const patientData = _get(patient, 'patientData') || {};
        if (!isOk) {
            isError = true;
            errMessage = _get(resp, 'data.error_message') || 'Data tidak ditemukan';
            // check for 404
            if (!_isEmpty(patientData) && !isBpjs) {
                errMessage = 'Data tidak ditemukan, silahkan lengkapi form berikut';
            } else if (isBpjs && isNotFound) {
                errMessage = 'Data tidak ditemukan, silahkan masukkan ulang info yang dibutuhkan';
            }
        } else errMessage = 'Data ditemukan, silahkan isi data yang kurang lengkap';

        const showFormBPJS = (!isError && !_isEmpty(patientData));
        const showForm = isBpjs ? showFormBPJS : !_isEmpty(patientData);

        this.setState({
            isLoading: false,
            patient,
            isError,
            errMessage,
            showForm
        });

    }
    
    CheckinPatient = async (params) => {
        const { facility_id, ...payload } = params;
        const [err, response] = await to(OKAPI.qms.CheckinPatient(facility_id, payload));
        if (err) {
            return _get(err, 'data', {});
        }
        return _get(response, 'data', {});
    }

    resetError = () => {
        this.setState({
            isError: false,
            patient: {},
            showForm: false,
            isBpjs: false,
            errMessage: ''
        });
    }

    render() {
        const value = {
            ...this.state,
            actions: {
                findPatient: this.findPatient,
                CheckinPatient: this.CheckinPatient,
                resetError: this.resetError
            }
        };
        
        return (
            <QueueFindContext.Provider value={value}>{this.props.children}</QueueFindContext.Provider>
        );
    }
}

export { QueueFindProvider, QueueFindContext };